import {
  FormikInput,
  LoadingButton,
  Stack,
  Typography,
  useResponsive,
  useTheme
} from '@rabex-kit/rabex-ui';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { ClearButton } from '../AuthIconButton';
import Confetti from '../../static/images/svg/Confetti.svg';
import { GoogleRegisterRequestBody } from '../../services/auth/types';

export type RegisterProps = {
  isLoading: boolean;
  onSubmit?: (values: GoogleRegisterRequestBody) => void;
};

const RegisterForm: React.FC<RegisterProps> = ({ onSubmit, isLoading }) => {
  const { matches } = useResponsive();
  const theme = useTheme();

  const handleSubmit = (values: GoogleRegisterRequestBody) => {
    onSubmit && onSubmit(values);
  };
  const validationSchema = yup.object({
    parentReferralCode: yup.string().optional()
  });

  return (
    <Stack gap={0} width={{ xs: '100%', lg: 464 }} mt={{ lg: 5, xs: 0 }}>
      <Stack gap={2} mb={{ xs: 3, lg: 6 }}>
        <Typography
          variant={matches({ lg: 'subtitle', xs: 'body1' })}
          weight="bold">
          کد معرف
        </Typography>
        <Typography
          variant={matches({ lg: 'body2', xs: 'body3' })}
          color="textColor.400">
          در صورت دعوت دوست‌تان به رابکس، کد دعوت او را در این قسمت وارد کنید.
        </Typography>
      </Stack>
      <Formik
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        initialValues={{
          parentReferralCode: '',
          acceptTerms: true
        }}>
        {(formik) => (
          <Form>
            <Stack flexDirection="row" gap={1} mb={3}>
              <Typography
                variant="body2"
                weight="bold"
                color={theme.palette.textColor.A80}>
                کد معرف
              </Typography>
              <Typography variant="body2" color={theme.palette.textColor[400]}>
                (اختیاری)
              </Typography>
            </Stack>
            <FormikInput
              endAdornment={
                <>
                  {formik.values.parentReferralCode && (
                    <ClearButton
                      spacing="mr"
                      onClick={() =>
                        formik.setFieldValue('parentReferralCode', '')
                      }
                    />
                  )}
                  <img src={Confetti} alt="" aria-hidden />
                </>
              }
              name="parentReferralCode"
              type="text"
              placeholder="کد معرف خود را وارد کنید"
            />
            <Typography
              variant="body2"
              py={{ xs: 4, lg: 6 }}
              color={theme.palette.textColor[400]}>
              با ثبت‌نام&nbsp;
              <a
                href="https://rabex.ir/terms"
                style={{
                  textDecoration: 'none',
                  color: theme.palette.textColor.A80
                }}>
                <b>شرایط و قوانین</b>&nbsp;
              </a>
              را می‌پذیرم.
            </Typography>
            <LoadingButton
              loading={isLoading}
              size={matches({ xs: 'md', lg: 'lg' })}
              type="submit"
              fullWidth
              color="primary">
              ادامه
            </LoadingButton>
          </Form>
        )}
      </Formik>
    </Stack>
  );
};

export default RegisterForm;
